<template>
  <div>
    <van-row class="container">
     
        <div  v-for="item in myMenuList" :key="item.cookbookId" class="my_list">
          <div @click="editInfo(item.cookbookId,'detailMenu')"  class="img_border">
            <van-image
              fit="cover"
              :src="
                item.cookbookUrl
                  ? item.cookbookUrl
                  : require('@/assets/头像图片.png')
              "
            />
            <div class="my_menu_list">
              <p style="margin-bottom: 8px" class="text_ccc goods_over">
                {{ item.name }}
              </p>
              <div class="menu_item">
                <span class="text_999 fSize_12"
                  >{{ item.estimateTime }}分钟左右</span
                >
                <div class="float_right text_yellow">
                  <span>￥{{ item.unitPrice | filterNumTwo }}</span>
                  <span class="fSize_10">/份</span>
                </div>
              </div>
            </div>
          </div>
          <div class="my_list_btn">
              <van-button
                round
                @click.stop="removeInfo(item.cookbookId)"
                type="info"
                size="mini"
                plain
                color="rgb(116, 180, 43)"
                >删除</van-button
              >
            
              <van-button
                round
                type="info"
                size="mini"
                @click.stop="editInfo(item.cookbookId, 'editMenu')"
                color="rgb(116, 180, 43)"
                >修改</van-button
              >
          </div>
        </div>
      
    </van-row>
    <!-- <van-icon @click='addMenu()'  name="plus" /> -->
    <van-row class="add_row mgTop20" offset="1" span="22">
      <van-button
        class="addBtn"
        icon="plus"
        hairline
        plain
        @click="editInfo('', 'editMenu')"
        round
        type="default"
        size="large"
      >
        添加菜谱</van-button
      >
    </van-row>
  </div>
</template>
<script>
export default {
  components: {},
  created() {
    this.cusCookbookList();
  },

  data() {
    return {
      myMenuList: [],
      isLoading: false
    };
  },

  methods: {
    editInfo(cookbookId, opeation) {
      this.$router.push({
        path: `/menuList/${opeation}`,
        query: {
          cookbookId,
          remark: "my"
        }
      });
    },
    onRefresh() {
      this.isLoading = true;
      this.$axios.post("trade/tradeCookbook/customerList", {}).then(res => {
        this.myMenuList = res.data.data;
        this.isLoading = false;
        this.$toast("刷新成功");
      });
    },
    ///tradeCookbook/customerList
    cusCookbookList() {
      this.$axios.post("trade/tradeCookbook/customerList", {}).then(res => {
        this.myMenuList = res.data.data;
      });
    },
    removeInfo(id) {
      this.$dialog
        .confirm({
          title: "提示",
          message: "确认删除？",
          confirmButtonColor: "#74b42b"
        })
        .then(() => {
          // on confirm
          this.$axios.delete(`trade//tradeCookbook/${id}`).then(() => {
            this.cusCookbookList();
            this.$toast.success("删除成功");
          });
        })
        .catch(() => {
          // on cancel
        });
    },
    addMenu() {
      ///orderList/send
      this.$router.push({
        path: "/menuList/addMenu"
      });
    }
  }
};
</script>

<style lang ='scss' scoped>
.container {
  padding: 4px 10px 50px 10px;
}
.index {
  padding-top: 120px;
  transition: all 1s;
  background: rgba(242, 242, 242, 1);
  padding-bottom: 60px;
}
.addBtn.van-button--large {
  height: 36px;
  border: 1px solid rgb(116, 180, 43);
  color: rgb(116, 180, 43);
  background: #f2f7ec;
  .van-button__icon + .van-button__text {
    margin-left: 7px;
  }
  .van-button__icon {
    width: 16px;
    height: 16px;
    line-height: 16px;
  }
}
.addBtn.van-hairline--surround::after {
  border: none;
}
.btnEdit /deep/ .van-button {
  padding: 5px 22px;
}

.my_list {
  /* background-image: url(imgs/矩形.png); */
  background: rgba(255, 255, 255, 1);
  /* background-color: pink; */
  box-shadow: 0px 0px 4px 1px rgba(153, 153, 153, 0.1);
  border-radius: 10px;
  /* background-repeat: no-repeat;
  background-position-x: 50%; */
  height: 157px;
  padding: 10px 20px;
  box-sizing: border-box;
  /* background-size: 97% 100%; */
  /* margin-bottom: 5px; */
  margin-bottom: 12px;
  .img_border {
    border-bottom: 1px solid rgba(151,151,151,0.1);
    padding: 0px 0px 5px 0px;
    overflow: hidden;
    .van-image {
      height: 88px;
      float: left;
      margin-right: 10px;
      width: 88px;
    }
  }
  .my_list_btn {
    /* display: flex;
    padding: 8px 14px 0px 0px;
    box-sizing: border-box; */
    padding-top: 12px;
    box-sizing: border-box;
    text-align: right;
    /deep/ .van-button {
      padding: 4px 22px;
      margin-left: 10px;
      height: 28px !important;
      line-height: initial !important;
    }
  }
}
.add_row {
  padding: 6px 18px;
  background: #f2f7ec;
  position: fixed;
  left: 0;
  bottom: 50px;
  width: 100%;
  box-sizing: border-box;
}
</style>